// Byrd Bound: Override product card prices with full_price + deposit display
document.addEventListener('DOMContentLoaded', function() {
  applyPriceOverride();
});

// Also run after any dynamic content loads
document.addEventListener('shopify:section:load', applyPriceOverride);

function applyPriceOverride() {
  // Find all product cards on the page
  var cards = document.querySelectorAll('.m-product-card, [data-product-card], .product-card');
  
  cards.forEach(function(card) {
    // Check if this card has a link to a signature edition product
    var link = card.querySelector('a[href*="premade-bibles"]');
    if (!link) return;
    
    var href = link.getAttribute('href');
    
    // Map product URLs to their full prices
    var priceMap = {
      'premade-bibles-2': { full: 445, label: 'Spider Man Edition' },
      'premade-bibles-3': { full: 585, label: 'Five Solas Edition' },
      'premade-bibles-4': { full: 500, label: 'Kingswood Edition' }
    };
    
    var matchedProduct = null;
    Object.keys(priceMap).forEach(function(slug) {
      if (href.indexOf(slug) !== -1) {
        matchedProduct = priceMap[slug];
      }
    });
    
    if (!matchedProduct) return;
    
    // Find the price element and replace it
    var priceEl = card.querySelector('.m-product-card__price, .product-card__price, [class*="price"]');
    if (!priceEl) return;
    
    // Only replace if it hasn't been replaced already
    if (priceEl.getAttribute('data-bb-overridden')) return;
    priceEl.setAttribute('data-bb-overridden', 'true');
    
    priceEl.innerHTML = '<span style="font-size:inherit;color:inherit;">$' + matchedProduct.full + '</span>' +
      '<span style="display:block;font-size:11px;letter-spacing:1.5px;text-transform:uppercase;opacity:0.7;margin-top:2px;">$200 deposit</span>';
  });
}
